import isApiError from "@insite/client-framework/Common/isApiError";
import { ApiParameter, post, ServiceResult } from "@insite/client-framework/Services/ApiService";
import { BaseModel, WarehouseModel } from "@insite/client-framework/Types/ApiModels";

export interface GetCustomerWarehouseParameter extends ApiParameter {
    billTo: string,
    shipTo: string
}

export interface GetCustomerWarehouseResult extends BaseModel {
    warehouse: WarehouseModel;
}

const apiUrl = "/api/v1/thosWarehouseExtended/getCustomerWarehouse";

export async function GetCustomerWarehouse(parameter: GetCustomerWarehouseParameter): Promise<ServiceResult<WarehouseModel>> {
    try {
        const warehouse = await post<GetCustomerWarehouseParameter, WarehouseModel>(apiUrl, parameter)
        return {
            successful: true,
            result: warehouse
        }
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        throw error;
    }
}